const searchBtn = document.querySelectorAll('[js-search-btn]')
const searchClose = document.querySelector('[js-search-close]')
const searchModal = document.querySelector('[js-search-modal]')

let isOpen = false

if(searchModal) {
  for(const btn of searchBtn) {
    btn.addEventListener('click', () => {
      if(isOpen) {
        searchModal.classList.remove('is-open')
      } else {
        searchModal.classList.add('is-open')
      }
  
      isOpen = !isOpen
    })
  
  }

  searchClose.addEventListener('click', () => {
    searchModal.classList.remove('is-open')

    isOpen = !isOpen
  })
}